import {
  DataGridWithCheckbox,
  type GridValidRowModel,
  type DataGridWithCheckboxProps,
} from '@shared/components';

export type BaseExamAssigningDataGridProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridWithCheckboxProps<TRowModel>,
  'rowHeight' | 'disableColumnMenu' | 'sx'
>;

export default function BaseExamAssigningDataGrid<T extends GridValidRowModel>(
  props: Readonly<BaseExamAssigningDataGridProps<T>>,
) {
  return (
    <DataGridWithCheckbox
      {...props}
      rowHeight={48}
      disableColumnMenu
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiButtonBase-root': {
          p: theme.spacing(0),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          px: theme.spacing(3),
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
